export const hostname = window.location.hostname
export const baseDomain = hostname === 'localhost' ? 'pos.vaporshop.dev' : hostname
export const appTitle = 'Vaporshop Point-of-Sale'
export const fuzzyStopWords = ['a', 'the', 'in', 'by', '/']
export const cookieDomain = hostname === 'localhost' ? 'localhost' : `.${hostname.slice(hostname.indexOf('.') + 1)}`
export const S3BucketUrl = 'https://s3-eu-west-1.amazonaws.com/vaporshop-store/'

const variables = {
  apiBaseUrl: `https://${baseDomain}/api`,
  appTitle,
  baseUrl: `https://${baseDomain}`,
  defaultLocale: 'en',
  devMode: hostname === 'localhost' || hostname === 'pos.vaporshop.dev',
  fuzzyStopWords: fuzzyStopWords,
  secondaryLocale: 'nl',
  S3BucketUrl
}

export default variables
